<template>
  <el-dialog
    title="UPLOAD NEW PRODUCTION FW"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="450px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="95px">
        <el-form-item label="Version" prop="fWVersion">
          <el-input v-model="form.fWVersion"></el-input>
        </el-form-item>
        <el-form-item label="Type" prop="type" class="mb-5">
          <el-select v-model="form.type" class="wp-100">
            <el-option
              v-for="item in typeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="MD5 Value"
          prop="md5Value"
          class="mt-10"
          v-if="form.type === 'Node'"
        >
          <el-input v-model="form.md5Value"></el-input>
        </el-form-item>
        <el-form-item label="Environment" prop="environment" class="mb-5">
          <el-checkbox-group v-model="form.environment">
            <el-checkbox
              v-for="item in environmentOptions"
              :key="item"
              :label="item"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Date" prop="firmwareDate" class="mb-0">
          <div>
            {{ moment().format('DD/MM/YYYY @ hh:mma') }}
          </div>
        </el-form-item>
        <el-form-item label="File" prop="file">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            :http-request="customUpload"
            :multiple="false"
            :limit="1"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
          >
            <el-button
              slot="trigger"
              size="small"
              class="mini-btn"
              type="primary"
              >Choose File</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import moment from 'moment'
import { environments } from '../../../const'
export default {
  data() {
    return {
      moment,
      environments,
      dialogVisible: false,
      loading: false,
      form: {
        fWVersion: '',
        environment: [],
        type: '',
        firmwareDate: '',
        file: '',
        md5Value: ''
      },
      rules: {
        fWVersion: [
          {
            required: true,
            message: 'Version is required'
          }
        ],
        type: [
          {
            required: true,
            message: 'Type is required'
          }
        ],
        file: [
          {
            required: true,
            message: 'File is required'
          }
        ]
      },
      typeOptions: [
        'Electrical',
        'Functional',
        'Production',
        'Node',
        'OTA',
        'BLE'
      ],
      environmentOptions: [environments.staging, environments.production]
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    resetForm() {
      this.form = {
        fWVersion: '',
        environment: [],
        type: '',
        firmwareDate: '',
        file: ''
      }
      this.$refs['upload'].clearFiles()
      this.$refs['form'].resetFields()
    },
    beforeUpload(file) {
      const isLt15M = file.size / 1024 / 1024 <= 15
      const isCorrectFileType =
        file.name.indexOf('.img') > -1 ||
        file.name.indexOf('.hex') > -1 ||
        file.name.indexOf('.bin') > -1 ||
        file.name.indexOf('.zip') > -1
      if (!isLt15M) {
        this.$message.error('The uploaded file size should not exceed 15Mb!')
        return false
      }
      if (!isCorrectFileType) {
        this.$message.error(
          'The uploaded file type should be img file, hex file, bin file or zip file!'
        )
        return false
      }
      return isLt15M && isCorrectFileType
    },
    handleRemove() {
      this.form.file = ''
    },
    customUpload(e) {
      this.form.file = e.file
    },
    formatParams() {
      let user = JSON.parse(localStorage.getItem('user'))
      let params = new FormData()
      params.append('fWVersion', this.form.fWVersion)
      params.append('type', this.form.type)
      params.append('firmwareDate', moment().format('YYYY-MM-DD HH:mm:ss'))
      params.append('file', this.form.file)
      params.append('userId', user.id)
      params.append(
        'isStaging',
        this.form.environment.indexOf(this.environments.staging) > -1
      )
      params.append(
        'isProduction',
        this.form.environment.indexOf(this.environments.production) > -1
      )

      if (this.form.type === 'Node') {
        params.append('md5Value', this.form.md5Value)
      }
      return params
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.UploadFirmImgFile(this.formatParams())
            .then(response => {
              this.loading = false
              if (response.data.success) {
                this.closeDialog()
                this.$parent.getData()
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(error => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: error.response.data.title
              })
            })
        }
      })
    }
  }
}
</script>
